import { deleteAtPath, setAtPath } from "./path-utils";

export function setStringField(
  root: unknown,
  path: string,
  value: string,
  optional: boolean,
): unknown {
  return optional && value === ""
    ? deleteAtPath(root, path)
    : setAtPath(root, path, value);
}
